import React from 'react';
import styled from 'astroturf/react';

const Container = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Heading = styled.header`
  @import 'stylesheets/design_system/font';
  @include body__medium-medium;

  display: flex;
  padding: var(--spacing-xs-16, 16px) 0px var(--spacing-xs-8, 8px) 0px;
  align-items: center;
  align-self: stretch;

  color: var(--text-primary, #141413);
  border-top: 1px solid var(--stroke-dark, #141413);
`;

type Props = {
  heading: React.ReactNode;
  compact?: boolean;
};

export const SidebarSection: React.FC<React.PropsWithChildren<Props>> = ({
  heading,
  compact,
  children,
}) => {
  return (
    <Container
      style={{
        gap: compact
          ? 'var(--spacing-xs-16, 16px)'
          : 'var(--spacing-sm-24, 24px)',
      }}
    >
      <Heading>{heading}</Heading>
      {children}
    </Container>
  );
};
